import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {


  constructor() { }
  setValidation(formGroup, validations, variables?) {
    if (validations.length != undefined && validations.length > 0) {
      for (let i = 0; i < validations.length; i++) {
        return this.validaters(formGroup, validations[i], variables);
      }
    }
  }
  validaters(formGroup, validations, variables?) {
    let item = formGroup.question_component.form.value;
    //this line is added as in form value sets later once the validation happens but we need to chk before setting in the form
    item[formGroup.question_component.question.key] = formGroup.value;
    switch (validations.validation_type) {
      case 'compare':
        if (eval(validations.expression)) {
          formGroup.setErrors(null);
          // for control_to_validate
          this.setdependentValidation(formGroup, validations, null);
        }
        else {
          // if (item['applicableFromDate'] == null || item['applicableToDate'] == null) {
          //   return {}
          // }
          // else
          this.setdependentValidation(formGroup, validations, { 'incorrect': true });
          return {
            invalid: true
          }
        }
        break;
      case 'required':
        //type is checked as in some cases value is in the form of object eg date range picker will be inhanced to arrays 
        if (typeof formGroup.value == 'object') {
          return this.setobjectValidation(formGroup);
        }
        else {
          return this.setstringValidation(formGroup);
        }
        break;
      case 'minDateNumber':
        return this.checkMindateNumber(formGroup, variables);
        break;
      default:
        //do nothing
        break;
    }
  }
  setobjectValidation(formGroup) {
    formGroup['question_component']['question']['key']
    let obj = formGroup.value;
    for(let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null || obj[key] === '') {
          return {
            invalid: true
          }
        }
      }
    }
    //if loops run completly than field is valid so making validator null
    formGroup.setErrors(null);
  }
  setstringValidation(formGroup) {
    if (formGroup.value != undefined && formGroup.value) {
      formGroup.setErrors(null);
    }
    else {
      return {
        invalid: true
      }
    }

  }
  checkMindateNumber(formGroup, variables) {
    let question = formGroup.question_component.question;
    if (question.minDateNumber != undefined && question.minDateNumber === 0 && variables.disabledMinutes.indexOf(variables.selectedMinute) > -1) {
      return {
        invalid: true
      }
    }
    else {
      formGroup.setErrors(null);
    }
  }
  //set validation for the control_to_validate in case of compare can be used further in case of setting validation over dependents
  setdependentValidation(formGroup, validations, error_?) {
    if (validations.control_to_validate != undefined) {
      if (Array.isArray(validations.control_to_validate)) {
        if (validations.control_to_validate) {
          for (let i = 0; i < validations.control_to_validate.length; i++) {
            formGroup._parent.controls[validations.control_to_validate[i]].setErrors(error_);
          }
        }
      }
      else {
        formGroup._parent.controls[validations.control_to_validate].setErrors(error_);

      }
    }
    else {//do nothing
    }

  }

}
